import './index.css';
import * as React from 'react';
import ScenceTab from '@/components/HomePage/ScenceTab';
import { ScenceTabItemData } from '@/components/HomePage/ScenceTab/component';

interface State {

}
interface Props {
  apiData: any;
}

export default class ChannelListScenceTab extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  onClickItem = (item: ScenceTabItemData) => {
    globalThis.eventBus.publish(SceneTabBarOnClickedEventBusKey, item);
  }

  render() {
    const { log_info } = this.props.apiData;
    const cid = log_info?.cid || '-999';
    return (
      <view style={{ width: '100%' }}>
        <ScenceTab cid={cid} moduleData={this.props.apiData} onClickItem={this.onClickItem} />
      </view>
    );
  }
}

export const SceneTabBarOnClickedEventBusKey = 'SceneTabBarOnClickedEventBusKey';
